import { useMemo } from 'react';
import { debug } from 'zf-web-infra';
import { DataNode } from 'antd/es/tree';
import { DataSource } from '../types';
import { TreeService } from '../service';

/**
 * 转换数据格式：列表转树，一并将图标名转换为图标组件
 * @param service
 * @param data
 * @returns
 */
export function useTreeData(service: TreeService, source: DataSource): DataNode[] {
  debug.common('useTreeData');

  // 将字符串转换为图标
  return useMemo(() => service.toTree(source), [service, source]);
}
